// Predefined configuration for launching the tilled popup window
export function launchApplicationPopup(tilledOnboardingUrl: string) {
  window.open(tilledOnboardingUrl, 'tilled-merchant-onboarding', 'popup');
}
